import React from 'react'
import { localize } from '../../util/Localizer'
import { Row, Col } from 'react-flexbox-grid'
import TextField from '@material-ui/core/TextField'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'

const displaySnackbar = (props) => {
  if (!props.pageErrors) {
    return
  }

  return (
    <Snackbar
      open={props.openSnackBar}
      autoHideDuration={4000}
      onClose={props.closeSnackBar}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
    >
      <SnackbarContent
        style={{ backgroundColor: '#B00000 !important', textAlign: 'center' }}
        message={<p>{props.pageErrors.message} {props.pageErrors.friendlyCode}</p>}
      /></Snackbar>
  )
}

const StepThree = (props) => {
  const conditions = localize('pages.activate.stepThree.condition')
  return (
    <section className='activate activateStep3 col-xs-12'>
      <Row>
        <Col xs={12}>
          <h3>{localize('pages.activate.stepThree.title')}</h3>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <form>
            <TextField
              id='conditionsText'
              multiline
              margin="normal"
              rows={20}
              value={conditions}
              fullWidth

            />
          </form>
        </Col>
      </Row>
      {displaySnackbar(props)}
    </section>
  )
}

export default StepThree



// WEBPACK FOOTER //
// ./src/widgets/activate/StepThree.js